import { beastStatusAtom, liveFeedbackCountDownAtom } from '@realtime';
import { useAtomValue } from 'jotai';

import { Box } from '@ui';

import { LiveActivitySidebar } from '../LiveActivitySidebar';
import { TopBar } from '../TopBar';

import { LiveAnalysisCameras } from './LiveAnalysisCameras';
import { LiveAnalysisParameters } from './LiveAnalysisParameter';
import * as css from './styles.css';

const SetupCountDown = () => {
    const countDownEvent = useAtomValue(liveFeedbackCountDownAtom);
    const currentNubmer = countDownEvent?.countDown;
    return (
        <Box className={css.countDownBox} id="setup">
            <p className={css.countDownText}>{currentNubmer}s</p>
        </Box>
    );
};

export const LiveAnalysisView = () => {
    const beastStatus = useAtomValue(beastStatusAtom);
    const countDownEvent = useAtomValue(liveFeedbackCountDownAtom);
    const isSetup = beastStatus === 'LIVE_FEEDBACK_WAITING_FOR_P1' && !!countDownEvent?.countDown;
    return (
        <Box className={css.fullscreen}>
            <TopBar />
            <Box className={css.withSidebar}>
                <LiveActivitySidebar />
                <Box height="100%" display="flex" flexDirection="column">
                    <LiveAnalysisCameras />
                    <LiveAnalysisParameters />
                </Box>
            </Box>
            {isSetup && <SetupCountDown />}
        </Box>
    );
};
